import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';

import './PlainTablePlaceholder.scss';

const getRandomInt = (maxValue) => {
    return Math.floor(Math.random() * Math.floor(maxValue)) + maxValue / 3;
};

const PlainTableColPlaceholder = (props) => {
    const random = getRandomInt(250);
    return <td>
        <ContentLoader
            height={60}
            width={400}
            speed={1}
            primaryColor="#EDEEF3"
            secondaryColor="#f3f3f3"
            {...props}
        >
            <rect x="0" y="20" rx="10" ry="10" width={random} height="30"/>
        </ContentLoader>
    </td>;
};

const PlainTablePlaceholder = ({ numberOfColumns, numberOfRows }) => {

    return (
        <table className='plainTablePlaceholder'>
            <tbody>
                {
                    Array(numberOfRows).fill('').map((value, index) => {
                        return <tr key={index}>
                            {
                                Array(numberOfColumns).fill('').map((value, index2) => {
                                    return <PlainTableColPlaceholder key={index2}/>;
                                })
                            }
                        </tr>;
                    })
                }
            </tbody>
        </table>
    );
};

PlainTablePlaceholder.propTypes = {
    numberOfColumns: PropTypes.number,
    numberOfRows: PropTypes.number
};

PlainTablePlaceholder.defaultProps = {
    numberOfColumns: 3,
    numberOfRows: 20
};

export default PlainTablePlaceholder;
